import getMailboxJunkEmailConfiguration from '../services/getMailboxJunkEmailConfiguration';
import updateMailboxJunkEmailConfiguration from './updateMailboxJunkEmailConfiguration';
import type { MailboxInfo } from 'owa-client-types';

export default async function initMailboxJunkEmailConfiguration(
    mailboxInfo: MailboxInfo
): Promise<void> {
    const mailboxConfiguration = await getMailboxJunkEmailConfiguration(mailboxInfo);
    updateMailboxJunkEmailConfiguration(mailboxConfiguration, mailboxInfo, true);
}
